module.exports = "https://coursera_assets.s3.amazonaws.com/images/93b559997c6299297da9f24219a32a39.svg";